import React from 'react'
import { useState } from 'react';

export default function Card({data,func}) {
    async function handleDelete(){
        console.log(data.id)
        fetch(`https://crud22.onrender.com/notes/${data.id}`, {
        method: "DELETE",
        headers: { 'Content-Type': "application/json"}
    })
    func();
    }
    const book=JSON.parse(localStorage.getItem("bookmarks")) || []

    function bookmark(){
        book.push(data)
        localStorage.setItem("bookmarks",JSON.stringify(book))
    }
    
  return (
    <div>
        <div>
        
            <div>
                <h2>{data.title}</h2>
                <p>{data.describe}</p>
                <h4>{data.date}</h4>
                <button 
                    onClick={handleDelete}
                >delete</button>
                <button
                    onClick={bookmark}
                >bookmark</button>
            </div>
            
        </div>
    </div>
  )
}
